/* Shared recommendations; never changes cart items, totals, or checkout. */
(function () {
  'use strict';
  function renderSuggestions() {
    var source = document.querySelector('template[data-db-suggestions-source]');
    var enabled = source && source.getAttribute('data-enabled') === 'true';
    var populated = enabled && source.content.querySelector('.db-cart-suggestion');
    document.querySelectorAll('[data-db-suggestions-slot]').forEach(function (slot) {
      while (slot.firstChild) slot.removeChild(slot.firstChild);
      slot.hidden = !populated;
      if (populated) slot.appendChild(source.content.cloneNode(true));
      var mini = slot.closest('.mini-cart-content');
      if (mini) mini.classList.toggle('db-mini-has-suggestions', !!populated);
      var layout = slot.closest('[data-db-cart-layout]');
      if (layout) layout.classList.toggle('db-cart-layout--suggestions', !!populated);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderSuggestions);
  } else {
    renderSuggestions();
  }
  document.addEventListener('shopify:section:load', renderSuggestions);
  document.addEventListener('shopify:section:reorder', renderSuggestions);
  document.addEventListener('shopify:block:select', function (event) {
    var blockId = event.detail && event.detail.blockId;
    document.querySelectorAll('[data-db-suggestion-block]').forEach(function (card) {
      if (card.getAttribute('data-db-suggestion-block') === blockId) {
        card.scrollIntoView({block: 'nearest', inline: 'nearest'});
      }
    });
  });
}());
